<h1 class="modal-title">
    <slot></slot>
</h1>

<style lang="less">
    .modal-title {
        font-size: 1.3em;
    }
</style>